/**
 * Skeleton pour une carte de procédure
 */
export function ProcedureCardSkeleton() {
    return (
        <div className="bg-card rounded-[12px] border border-border overflow-hidden animate-pulse">
            <div className="w-full flex flex-col items-center justify-center px-[20px] py-[24px]">
                {/* Icon Circle Skeleton */}
                <div className="rounded-full h-[56px] w-[56px] bg-muted mb-[12px]" />

                {/* Name Skeleton */}
                <div className="h-4 bg-muted rounded w-3/4 mb-[8px]" />

                {/* Description Skeleton */}
                <div className="h-3 bg-muted rounded w-full mb-1" />
                <div className="h-3 bg-muted rounded w-2/3" />
            </div>
        </div>
    );
}

/**
 * Skeleton pour la grille de procédures
 * @param {Object} props
 * @param {number} [props.count=8] - Nombre de skeletons à afficher
 */
export function ProceduresGridSkeleton({ count = 8 }) {
    return (
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-[15px]">
            {[...Array(count)].map((_, i) => (
                <ProcedureCardSkeleton key={i} />
            ))}
        </div>
    );
}

/**
 * Skeleton pour le détail d'une procédure
 */
export function ProcedureDetailSkeleton() {
    return (
        <div className="animate-pulse p-6 space-y-6">
            {/* Header */}
            <div className="flex items-center gap-4">
                <div className="rounded-full h-16 w-16 bg-muted" />
                <div className="flex-1">
                    <div className="h-6 bg-muted rounded w-1/3 mb-2" />
                    <div className="h-4 bg-muted rounded w-2/3" />
                </div>
            </div>

            {/* Actions */}
            <div className="flex gap-3">
                <div className="h-10 bg-muted rounded-lg w-24" />
                <div className="h-10 bg-muted rounded-lg w-24" />
                <div className="h-10 bg-muted rounded-lg w-24" />
            </div>

            {/* Table Header */}
            <div className="h-12 bg-muted rounded-lg" />

            {/* Table Rows */}
            <div className="space-y-3">
                {[...Array(5)].map((_, i) => (
                    <div key={i} className="h-16 bg-surface rounded-lg" />
                ))}
            </div>
        </div>
    );
}

/**
 * Skeleton pour le formulaire de procédure
 */
export function ProcedureFormSkeleton() {
    return (
        <div className="animate-pulse space-y-6 p-6">
            {/* Nom */}
            <div>
                <div className="h-4 bg-muted rounded w-32 mb-2" />
                <div className="h-10 bg-muted rounded-lg" />
            </div>

            {/* Description */}
            <div>
                <div className="h-4 bg-muted rounded w-24 mb-2" />
                <div className="h-24 bg-muted rounded-lg" />
            </div>

            {/* Couleur */}
            <div>
                <div className="h-4 bg-muted rounded w-20 mb-2" />
                <div className="flex gap-2">
                    {[...Array(8)].map((_, i) => (
                        <div key={i} className="h-8 w-8 bg-muted rounded-full" />
                    ))}
                </div>
            </div>

            {/* Sections */}
            <div className="space-y-4">
                <div className="h-4 bg-muted rounded w-24" />
                <div className="h-32 bg-muted rounded-lg" />
                <div className="h-32 bg-muted rounded-lg" />
            </div>
        </div>
    );
}
